export default function pagination (page, total, limit) {
  const beforeCurrent = 3
  const afterCurrent = 3

  const pageCount = Math.ceil(total / limit)

  const hasPrev = page > 1
  const hasNext = page < pageCount

  const hasFirst = page >= 2 + beforeCurrent
  const hasFirstEllipsis = page >= beforeCurrent + 4
  const hasLast = page <= pageCount - (1 + afterCurrent)
  const hasLastEllipsis = page < pageCount - (2 + afterCurrent)

  const pages = []

  if (hasFirst) {
    pages.push({
      page: 1,
      isCurrent: Number(page) === 1,
      isEllipsis: false
    })
  }

  if (hasFirstEllipsis) {
    pages.push({
      page: false,
      isCurrent: false,
      isEllipsis: true
    })
  }

  let left = Math.max(1, page - beforeCurrent)
  if (left - 1 === 2) {
    left--
  }
  let right = Math.min(page + afterCurrent, pageCount)
  if (pageCount - right === 2) {
    right++
  }

  for (let i = left; i <= right; i++) {
    pages.push({
      page: i,
      isCurrent: Number(page) === i,
      isEllipsis: false
    })
  }

  if (hasLastEllipsis) {
    pages.push({
      page: false,
      isCurrent: false,
      isEllipsis: true
    })
  }

  if (hasLast) {
    pages.push({
      page: pageCount,
      isCurrent: Number(page) === Number(pageCount),
      isEllipsis: false
    })
  }

  return { pages, hasPrev, hasNext }
}
